/**
 * ネットワーク台帳の選択肢（for-select）API Contract。
 * dresscode-backend #8514 の
 * `it-force/api/_component/network-for-select/.../list-network-for-select.api-contract.ts` を写したもの。
 * publish 後は `@standandforce/api-contract` からの import に差し替える。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
import { pageSizeAllowingAllSchema, paginatedSchema, paginationQuerySchema } from './pagination';
const MAX_FREE_TEXT_LENGTH = 256;
const NetworkForSelectOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  /**
   * 台帳に登録された IP（単一 IP 文字列。CIDR 非対応）。未登録は null。
   * IP 未登録も選択肢に含め、UI は null を「IP 未設定」として区別表示する。
   */
  ipAddress: z.string().nullable()
});
const NetworkForSelectListQuerySchema = paginationQuerySchema(z.enum(['name'])).extend({
  pageSize: pageSizeAllowingAllSchema(),
  freeText: z.string().max(MAX_FREE_TEXT_LENGTH).optional()
});
export const networkForSelectContract = oc.router({
  list: oc.route({
    method: 'GET',
    path: '/v2/components/networks-for-select'
  }).input(NetworkForSelectListQuerySchema).output(paginatedSchema(NetworkForSelectOptionSchema))
});